// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   COMMON DYNAMIC TABLE STYLES
================================ */

/* Main Table Wrapper */
.tbl-main {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fff;
    position: relative;
}

/* Table */
.tbl-main table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
}

/* Header */
.tbl-main thead th {
    background: #f7f8fa;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #ddd;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 5;
}

/* Table cells */
.tbl-main th,
.tbl-main td {
    padding: 8px 10px;
    border-bottom: 1px solid #eee;
    vertical-align: middle;
}

/* Hover */
.tbl-main tbody tr:hover {
    background-color: #f9fbff;
}

/* Fixed Header Container */
.tbl-fixed-header {
    max-height: 65vh;
    overflow-y: auto;
}

/* ================================
   FREEZE LAST COLUMN
================================ */

.table-col-freeze {
    position: relative;
}

.table-col-freeze th.last-col-freeze,
.table-col-freeze td.last-col-freeze {
    position: sticky;
    right: 0;
    background: #fff;
    z-index: 6;
    border-left: 1px solid #ddd;
}

/* Header z-index higher */
.table-col-freeze thead th.last-col-freeze {
    z-index: 7;
    background: #f7f8fa;
}

/* ================================
   ACTION BUTTONS
================================ */

.tbl-main .btn {
    padding: 4px 6px;
    line-height: 1;
}

.tbl-main .material-icons-outlined {
    font-size: 18px;
}

/* ================================
   PAGINATION
================================ */

.pagination {
    margin: 10px 0 0;
}

.pagination .page-item .page-link {
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    margin: 0 2px;
    color: #333;
}

.pagination .page-item.active .page-link {
    background: #556ee6;
    border-color: #556ee6;
    color: #fff;
}

.pagination .page-item.disabled .page-link {
    opacity: 0.6;
    pointer-events: none;
}

/* ================================
   EMPTY STATE
================================ */

.tbl-main .text-center {
    padding: 30px 0;
    color: #777;
}

/* ================================
   RESPONSIVE
================================ */

@media (max-width: 768px) {
    .tbl-fixed-header {
        max-height: 60vh;
    }

    .tbl-main table {
        font-size: 12px;
    }

    .tbl-main th,
    .tbl-main td {
        padding: 6px 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/learning-development/common/DynamicTable/dynamic-table.css"],"names":[],"mappings":"AAAA;;kCAEkC;;AAElC,uBAAuB;AACvB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA,gBAAgB;AAChB;;IAEI,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA,UAAU;AACV;IACI,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;kCAEkC;;AAElC;IACI,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;kCAEkC;;AAElC;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;kCAEkC;;AAElC;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;kCAEkC;;AAElC;IACI,eAAe;IACf,WAAW;AACf;;AAEA;;kCAEkC;;AAElC;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":["/* ================================\n   COMMON DYNAMIC TABLE STYLES\n================================ */\n\n/* Main Table Wrapper */\n.tbl-main {\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    background: #fff;\n    position: relative;\n}\n\n/* Table */\n.tbl-main table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 13px;\n}\n\n/* Header */\n.tbl-main thead th {\n    background: #f7f8fa;\n    font-weight: 600;\n    color: #333;\n    border-bottom: 1px solid #ddd;\n    white-space: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 5;\n}\n\n/* Table cells */\n.tbl-main th,\n.tbl-main td {\n    padding: 8px 10px;\n    border-bottom: 1px solid #eee;\n    vertical-align: middle;\n}\n\n/* Hover */\n.tbl-main tbody tr:hover {\n    background-color: #f9fbff;\n}\n\n/* Fixed Header Container */\n.tbl-fixed-header {\n    max-height: 65vh;\n    overflow-y: auto;\n}\n\n/* ================================\n   FREEZE LAST COLUMN\n================================ */\n\n.table-col-freeze {\n    position: relative;\n}\n\n.table-col-freeze th.last-col-freeze,\n.table-col-freeze td.last-col-freeze {\n    position: sticky;\n    right: 0;\n    background: #fff;\n    z-index: 6;\n    border-left: 1px solid #ddd;\n}\n\n/* Header z-index higher */\n.table-col-freeze thead th.last-col-freeze {\n    z-index: 7;\n    background: #f7f8fa;\n}\n\n/* ================================\n   ACTION BUTTONS\n================================ */\n\n.tbl-main .btn {\n    padding: 4px 6px;\n    line-height: 1;\n}\n\n.tbl-main .material-icons-outlined {\n    font-size: 18px;\n}\n\n/* ================================\n   PAGINATION\n================================ */\n\n.pagination {\n    margin: 10px 0 0;\n}\n\n.pagination .page-item .page-link {\n    padding: 4px 10px;\n    font-size: 12px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    margin: 0 2px;\n    color: #333;\n}\n\n.pagination .page-item.active .page-link {\n    background: #556ee6;\n    border-color: #556ee6;\n    color: #fff;\n}\n\n.pagination .page-item.disabled .page-link {\n    opacity: 0.6;\n    pointer-events: none;\n}\n\n/* ================================\n   EMPTY STATE\n================================ */\n\n.tbl-main .text-center {\n    padding: 30px 0;\n    color: #777;\n}\n\n/* ================================\n   RESPONSIVE\n================================ */\n\n@media (max-width: 768px) {\n    .tbl-fixed-header {\n        max-height: 60vh;\n    }\n\n    .tbl-main table {\n        font-size: 12px;\n    }\n\n    .tbl-main th,\n    .tbl-main td {\n        padding: 6px 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
